import type { StudentOccupiedSlots } from '~/features/student-slots/model'
import { IStudent } from '~/types/student'
import http from '~/utils/http'

/** 获取所有学生 */
export function getStudent(page: number, size: number) {
  return http.get('/admin/student', {
    params: {
      page,
      size,
    },
  })
}

/** 新增学生 */
export function postStudent(data: Partial<IStudent>) {
  return http.post('/admin/student', data)
}

/** 删除学生 */
export function deleteStudent(userId: string) {
  return http.delete(`/admin/student/${userId}`)
}

/** 编辑学生 */
export function patchStudent(userId: string, data: Partial<IStudent>) {
  return http.patch(`/admin/student/${userId}`, data)
}

export async function getStudentOccupiedSlots(
  studentId: string,
): Promise<StudentOccupiedSlots> {
  return (
    await http.get<StudentOccupiedSlots>(
      `/admin/student/${encodeURIComponent(studentId)}/occupied-slots`,
    )
  ).data
}
